import { Row, Col, Card, Table, Modal, message, Spin } from "antd";
import { ReactComponent as Logo } from "../../assets/images/Frame 2147225328.svg";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import styled from "styled-components";
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { CALL_API } from "../../Common/api";
import { nexusEventLabel, sortNexusEvents } from "./nexusEventLabels";
import { format, differenceInMinutes, parseISO, subHours } from "date-fns";
import { useLocation } from "react-router-dom";
import { ReactComponent as MapIcon } from "../../assets/images/Group 1000004561.svg";
import MapComponent from "../../Reusablecomponents/MapComponent";
import { TripStatusEnum } from "../../Common/constant";
import dayjs from "dayjs";
import moment from "moment";
import { useSelector } from "react-redux";
import { ReactComponent as EventActive } from "../../assets/images/event-over.svg";
import { ReactComponent as Calendar } from "../../assets/images/calendar.svg";
import { ReactComponent as Clock } from "../../assets/images/clock.svg";
import { deriveVehicleState } from "../LiveTrack/nexusVehicleState";
import { ReactComponent as GreenlocationIcon } from "../../assets/livetracking/greenlocationicon.svg";
import { ReactComponent as Line } from "../../assets/images/Line 1.svg";
import { TRAKING_API_BASE } from "../../Common/traking";

export const TitleStyle = styled.div`
  div[tabindex="0"] {
    width: 100% !important;
    height: 100vh !important;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .container_for_header_subtwo {
      display: flex;
      flex-wrap: wrap;
    }
    .container_for_headersub_three {
      display: flex;
      flex-wrap: wrap;
      justify-content: end;
    }
  }

  container_six {
    color: green;
  }
  .conatiner_seven {
    padding-top: 17px;
  }
  .container_five {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: block;
    background-color: green;
  }
  .container_five {
    color: green;
  }

  .container_three {
    margin-top: 2%;
  }
  .container_four {
    color: #151515;
    font-size: 1rem;
    font: inter;
    font-weight: 500;
  }
  .container_two > div {
    padding: 15px 5px 5px 15px;
  }
  .container_four {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .container_one {
    display: flex;
    justify-content: space-between;
    padding: 8px 8px 18px 8px;
    align-items: center;
    border-bottom: 1px solid #e7e7ed;
  }
  .container_one label {
    font-family: Inter;
    font-weight: 500;
    font-size: 3rem !important;
  }
  p {
    margin-bottom: 0px;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    color: #3d3d3d;
  }
  .container_Green {
    color: #2c963d;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Orange {
    color: #e4a400;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Red {
    color: #f20000;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }

  .trackright_logo {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    flex-direction: column;
    align-items: center;
  }
  .trackright_ai_cargo {
    font-size: 1rem;
    padding: 4px 4px 4px 4px;
  }
  .section_card_one {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .section-card {
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    background-color: #ffffff;
  }
  .items-key {
    position: relative;
    margin-bottom: 20px;
  }
  .Event-card {
    position: relative;
    padding-left: 24px;
  }
  .Event-card-line {
    position: absolute;
    left: 12px;
    top: 30px;
  }
  .Event-card-circle {
    position: absolute;
    left: 2px;
    top: -1px;
  }
  .Event-card-text {
    margin-left: 24px;
  }
  .Event-card-text-bold {
    font-weight: bold;
  }
  .Event-card-text-gray {
    color: #979797;
    font-size: 14px;
  }
  .Event-card-text-flex {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-clock {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar span,
  .Event-card-text-flex-clock span {
    margin-left: 4px;
    color: #979797;
    font-size: 14px;
  }
  .apcontainer_onee {
    width: 100%;
    height: 100%;
  }
  /* 
.mapcontainer_three{
  background-color:green!important;
}
.apcontainer_onee{
  width:100%;
  height:100%;
}
 .mapcontainer_eleven {
    width: 100px !important;
  } */

  /* .mapcontainer_one{
  width: 1500px !important;
height:  100%!important;
} */

  /* @media screen and (min-width: 768px) and (max-width: 1024px) {
    .mapcontainer_two {
      display: flex !important;
      flex-direction: column !important;
    }
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */

  /* @media screen and (min-width: 1025px) and (max-width: 1339px) {
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .mapcontainer_two {
      display: flex !important;
      flex-direction: column !important;
    }
    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */
  /* @media screen and (min-width: 1440px) and (max-width: 1980px) {
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .ant-row {
      flex-wrap: nowrap !important;
    }

    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */

  .title {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    width: 205;
    height: 17;
    color: #363636;
  }
  .textcolor {
    color: #363636;
  }
`;

// const stoppageColumns = [
//   {
//     title: "Location",
//     dataIndex: "Location",
//     key: "Location",
//     render: (text) => (
//       <div
//         style={{
//           wordWrap: "break-word",
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}
//       >
//         {text || "-"}
//       </div>
//     ),
//   },
//   {
//     title: "Started",
//     dataIndex: "Started",
//     key: "Started",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text?.split(" ");
//       const date = parts.slice(0, 3).join(" "); // "24th Aug 2024"
//       const time = parts.slice(3).join(" "); // "7:10am"

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Ended",
//     dataIndex: "Ended",
//     key: "Ended",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text?.split(" ");
//       const date = parts.slice(0, 3).join(" ");
//       const time = parts.slice(3).join(" ");

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Duration (HH:MM)",
//     dataIndex: "Duration",
//     key: "Duration",
//   },
// ];

const breakColumns = [
  {
    title: "Location",
    dataIndex: "FenceName",
    key: "FenceName",
  },
  {
    title: "Started",
    dataIndex: "BreakStartTime",
    key: "BreakStartTime",
    render: (value) =>
      value
        ? moment(value).subtract(3, "hours").format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Ended",
    dataIndex: "BreakEndTime",
    key: "BreakEndTime",
    render: (value) =>
      value
        ? moment(value).subtract(3, "hours").format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Duration (HH:MM)",
    dataIndex: "DurationMinutes",
    key: "DurationMinutes",
    render: (value) => {
      if (!value && value !== 0) return "-";

      const hours = Math.floor(value / 60);
      const minutes = value % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    },
  },
];

// const DeviaionColumn = [
//   {
//     title: "Location",
//     dataIndex: "Location",
//     key: "Location",
//     render: (text) => (
//       <div
//         style={{
//           wordWrap: "break-word",
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}
//       >
//         {text || "-"}
//       </div>
//     ),
//   },
//   {
//     title: "Started",
//     dataIndex: "Started",
//     key: "Started",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text.split(" ");
//       const date = parts.slice(0, 3).join(" "); // "24th Aug 2024"
//       const time = parts.slice(3).join(" "); // "7:10am"

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Ended",
//     dataIndex: "Ended",
//     key: "Ended",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text.split(" ");
//       const date = parts.slice(0, 3).join(" ");
//       const time = parts.slice(3).join(" ");

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Duration (HH:MM)",
//     dataIndex: "Duration",
//     key: "Duration",
//   },
// ];
const RouteDeviationData = [
  {
    key: "1",
    Location: "Nagercoil, TamilNadu, 629001, India",
    Started: "24th Aug 2024 7:10am",
    Ended: "24th Aug 2024 7:20am",
    Duration: " 02:35",
  },
  {
    key: "2",
    Location: "Nagercoil, TamilNadu, 629001, India",
    Started: "24th Aug 2024 7:10am",
    Ended: "24th Aug 2024 7:20am",
    Duration: "04:35",
  },
];
const NexusTrackLinkAI = () => {
  const { pathname, search } = useLocation();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const searchParams = new URLSearchParams(search);
  const tripId = pathname.split("/")[2]; // Gets "731"
  const vehId = searchParams.get("vehId"); // Gets "0"
  const mcId = searchParams.get("mcId"); // Gets "1"
  const shipmentTypeId = searchParams.get("shipmentTypeId"); // Gets "1"
  const [eventData, setEventData] = useState([]);
  const [consignTripData, setConsignTripData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [carbonfootprint, setCarbonfootprint] = useState(null);
  const [arrowicondetails, setArrowicondetails] = useState(null);
  const [routeData, setRouteData] = useState([]);
  const [nexusConsignData, setNexusConsignData] = useState([]);
  const [nexusEventData, setNexusEventData] = useState([]);
  const [nexusTrip, setNexusTrip] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem("selectedRecord");
    if (stored) {
      const record = JSON.parse(stored);
      setCarbonfootprint(record?.CarbonFootprint);
    }
  }, []);

  // Replace your current useEffect with this:
  const previousDataRef = useRef(null);
  const [locationCache, setLocationCache] = useState({});

  // Live position of THIS trip's vehicle, from TraKing (nexus/nexustracklive).
  // The AI endpoint used before looked the id up in the AI trips, which put the
  // marker at some other trip's vehicle.
  const tripilinkdetails = useCallback(async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `nexus/nexustracklive?tripId=${tripId}&mcId=${mcId}`,
      );
      if (data?.tripStatus === 4 && pollingRef.current) {
        clearInterval(pollingRef.current); // finished: no more live position
        pollingRef.current = null;
      }
      const v = data?.vehicle;
      const lat = Number(v?.latitude_decimal);
      const lng = Number(v?.longitude_decimal);
      const record =
        v && lat && lng && !Number.isNaN(lat) && !Number.isNaN(lng)
          ? {
              FLatitude: lat,
              FLongitude: lng,
              FAssetID: v.asset_name,
              FSpeed: Number(v.speed) || 0,
              FBattery: null, // TraKing has no battery reading
              // odometer in km; gps time is read from `mileage` by the map popup
              FMileage: v.odreading != null ? Number(v.odreading) : null,
              mileage: v.last_ping || v.device_datetime_utc || null,
              runstatus: ({ moving: "Moving", idle: "Idle", parked: "Stationary" })[
                deriveVehicleState(v)
              ] || "-",
            }
          : null;

      if (record?.FLatitude && record?.FLongitude) {
        const prev = previousDataRef.current;
        const latDiff = Math.abs((prev?.FLatitude || 0) - record.FLatitude);
        const lngDiff = Math.abs((prev?.FLongitude || 0) - record.FLongitude);

        if (!prev || latDiff > 0.001 || lngDiff > 0.001) {
          const locationKey = `${Number(record.FLatitude).toFixed(
            3,
          )},${Number(record.FLongitude).toFixed(3)}`;

          let locationName = locationCache[locationKey];
          if (!locationName) {
            locationName = await fetchLocation(
              record.FLatitude,
              record.FLongitude,
            );
            setLocationCache((prev) => ({
              ...prev,
              [locationKey]: locationName,
            }));
          }

          const newDetails = { ...record, locationName };
          previousDataRef.current = newDetails;
          setArrowicondetails(newDetails);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }, [tripId, mcId]);
  const pollingRef = useRef(null);
  useEffect(() => {
    tripilinkdetails();

    pollingRef.current = setInterval(() => {
      tripilinkdetails();
    }, 15000);

    return () => clearInterval(pollingRef.current);
  }, [tripilinkdetails]);

  const formatSecondsToHMS = (timeInSeconds) => {
    const totalSeconds = Number(timeInSeconds) || 0;

    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const mins = Math.floor((totalSeconds % (60 * 60)) / 60);

    const parts = [];

    if (days > 0) {
      parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else if (hours > 0) {
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else {
      // Only minutes if no hours or days
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    }

    return parts.join(" ");
  };

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();

      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };


  // Consignments + Events tables (nexusConsign / NexusDeliveryEvents)
  const lowerKeys = (row) =>
    Object.fromEntries(
      Object.entries(row || {}).map(([k, v]) => [k.toLowerCase(), v]),
    );

  // location names already looked up, so refreshing does not geocode every row again
  const eventLocationCache = useRef({});

  const fetchNexusTrackDetails = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const res = await CALL_API(
        "GET",
        `nexus/nexustrackdetails?tripId=${tripId}&mcId=${mcId}`,
      );
      const consignments = Array.isArray(res?.data?.consignments)
        ? res.data.consignments
        : [];
      // by the time each event happened, not the order the rows were received
      const events = sortNexusEvents(
        (Array.isArray(res?.data?.events) ? res.data.events : []).map(lowerKeys),
      );
      setNexusTrip(res?.data?.trip ? lowerKeys(res.data.trip) : {});
      // 1 = Delivery, 2 = Collection: the events are named differently
      const shipType =
        res?.data?.trip?.shipmenttype ??
        consignments[0]?.shipmentType ??
        consignments[0]?.shipmenttype;

      setNexusConsignData(
        consignments.map((row, index) => ({
          ...lowerKeys(row),
          key: row.consignid ?? row.ConsignId ?? index,
        })),
      );

      const eventsWithLocation = await Promise.all(
        events.map(async (ev, index) => {
          let locationName = ev.fencename || "Unknown Location";
          if (ev.lat && ev.lng) {
            const cacheKey = `${ev.lat},${ev.lng}`;
            if (!eventLocationCache.current[cacheKey]) {
              eventLocationCache.current[cacheKey] = await fetchLocation(ev.lat, ev.lng);
            }
            locationName = eventLocationCache.current[cacheKey];
          }
          return {
            ...ev,
            eventname: nexusEventLabel(ev.eventname, shipType),
            key: ev.id ?? `${ev.eventname}-${ev.dropseq ?? ""}-${ev.eventtime ?? ev.cron ?? index}`,
            locationName,
          };
        }),
      );
      setNexusEventData(eventsWithLocation);
    } catch (error) {
      console.error("Error in fetchNexusTrackDetails:", error);
      setNexusTrip({});
      setNexusConsignData([]);
      setNexusEventData([]);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const formatNairobiTime = (value) =>
    value ? moment.utc(value).utcOffset(180).format("Do MMM YYYY; hh:mm A") : "-";

  // Nexus fences (GET /traking/allFence) → geofence_id ⇒ name
  const [nexusFenceList, setNexusFenceList] = useState([]);

  const fetchNexusFences = async () => {
    try {
      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allFence`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );
      const data = await response.json();
      setNexusFenceList(Array.isArray(data?.response) ? data.response : []);
    } catch (error) {
      console.error("[fetchNexusFences] error:", error);
      setNexusFenceList([]);
    }
  };

  // Accepts a single geofence_id, an array of ids, or a comma-separated string
  const getFenceNames = (value) => {
    if (value == null || value === "") return "-";
    const ids = Array.isArray(value)
      ? value.flat()
      : String(value).split(",").map((s) => s.trim());
    const names = ids
      .filter((id) => id !== "" && id != null)
      .map(
        (id) =>
          nexusFenceList.find((f) => String(f.geofence_id) === String(id))
            ?.name || id,
      );
    return names.length ? names.join(", ") : "-";
  };

  // MapComponent (locationsTLAI) reads LAT/LNG/EventName/MODON and, when
  // FENCENAME is set, shows MODON minus 3h. Pass Nairobi wall time + 3h as a
  // zone-less string so the popup shows the correct Nairobi time.
  const mapEventData = useMemo(
    () =>
      nexusEventData
        .filter((ev) => ev.lat && ev.lng)
        .map((ev) => ({
          LAT: ev.lat,
          LNG: ev.lng,
          EventName: ev.eventname,
          FENCENAME: ev.fencename || ev.locationName || "-",
          MODON: ev.eventtime
            ? moment
                .utc(ev.eventtime)
                .utcOffset(180)
                .add(3, "hours")
                .format("YYYY-MM-DDTHH:mm:ss")
            : null,
          LocationName: ev.locationName,
        })),
    [nexusEventData],
  );

  // Trip summary from nexusTrip + nexusConsign (keys lower-cased)
  const nexusStatusLabel = (status) => {
    if (status === 4) return { label: "Completed", color: "#2C963D" };
    if (status === 3) return { label: "In-Progress", color: "#FA8C16" };
    if (status === 0 || status === 1) return { label: "Assigned", color: "#E4A400" };
    const label = TripStatusEnum.find((item) => item.value === status)?.label;
    return { label: label || "-", color: "#E4A400" };
  };

  const nexusSummary = useMemo(() => {
    const trip = nexusTrip || {};
    const first = nexusConsignData[0] || {};
    const pick = (...values) =>
      values.find((v) => v !== undefined && v !== null && v !== "");

    const consigneeNames = [
      ...new Set(
        nexusConsignData
          .map((c) => c.consigneename || getFenceNames(c.consignee))
          .filter((n) => n && n !== "-"),
      ),
    ];
    // events are ordered oldest first, so the latest is the last one
    const latestEvent = nexusEventData[nexusEventData.length - 1];

    // Total trip time = first to last event (seconds)
    const eventMs = nexusEventData
      .map((e) => new Date(e.eventtime).getTime())
      .filter((n) => !Number.isNaN(n));
    const tripSeconds =
      eventMs.length > 1
        ? Math.round((Math.max(...eventMs) - Math.min(...eventMs)) / 1000)
        : null;

    return {
      tripCode: pick(trip.tripcode, first.code),
      status: pick(trip.status, first.status),
      vehicleName: pick(trip.vehiclename, first.vehiclename),
      driverName: pick(trip.drivername, first.drivername),
      consignorName: pick(first.consignorname, getFenceNames(first.consigner)),
      consigneeNames,
      containerNo: pick(first.containerno, trip.containerno),
      deviceId: pick(trip.device, first.deviceid),
      deliveryNo: pick(first.deliveryno, trip.deliveryno),
      pickupTime: pick(first.pickuptime, trip.starttime),
      dropTime: first.droptime,
      carbonFootprint: pick(trip.carbonfootprint),
      distanceKm: pick(trip.gpskms),
      tripSeconds,
      lastLocation: pick(latestEvent?.fencename, latestEvent?.locationName),
      lastEventName: latestEvent?.eventname,
      lastEventTime: latestEvent?.eventtime,
      destination: consigneeNames[consigneeNames.length - 1],
    };
  }, [nexusTrip, nexusConsignData, nexusEventData, nexusFenceList]);

  const [timeandDist, setTimeandDist] = useState([]);

  const [breakData, setBreakData] = useState([]);

  const handleKPIAlerts = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `AIkpi/handleKPIAlerts`);
    } catch (error) {
      console.error("[handleKPIAlerts] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  // Planned route of the Nexus trip: consignor, then each consignee in drop order
  // (nexus/nexustrackroute), joined into a road route with Mapbox Directions.
  // MapComponent draws containerplanedRoutes.Table[0] (road points + From / To pins)
  // and the start / end of actualLocationsAI (consignTripData).
  const fetchNexusRoute = useCallback(async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `nexus/nexustrackroute?tripId=${tripId}&mcId=${mcId}`,
      );
      const points = Array.isArray(data?.waypoints) ? data.waypoints : [];
      if (points.length < 2) {
        setRouteData([]);
        setConsignTripData([]);
        return;
      }
      const origin = points[0];
      const last = points[points.length - 1];
      setConsignTripData([
        {
          StartLat: origin.lat,
          StartLng: origin.lng,
          EndLat: last.lat,
          EndLng: last.lng,
          DestinationName: last.name,
        },
      ]);

      // a start to end line is drawn by the map already; with stops in between
      // draw the full road route through them
      if (points.length > 2) {
        let line = points.map((pt) => ({ lat: pt.lat, lng: pt.lng }));
        try {
          const coords = points.map((pt) => `${pt.lng},${pt.lat}`).join(";");
          const res = await fetch(
            `https://api.mapbox.com/directions/v5/mapbox/driving/${coords}?geometries=geojson&overview=full&access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
          );
          const json = await res.json();
          const geometry = json?.routes?.[0]?.geometry?.coordinates;
          if (Array.isArray(geometry) && geometry.length) {
            line = geometry.map(([lng, lat]) => ({ lat, lng }));
          }
        } catch (error) {
          console.error("[fetchNexusRoute] directions error:", error);
        }
        setRouteData({
          Table: [
            {
              FRoadPoints: JSON.stringify(line),
              FStartCenterLat: origin.lat,
              FStartCenterLon: origin.lng,
              FEndCenterLat: last.lat,
              FEndCenterLon: last.lng,
            },
          ],
        });
      } else {
        setRouteData([]);
      }
    } catch (error) {
      console.error("[fetchNexusRoute] error:", error);
      setRouteData([]);
      setConsignTripData([]);
    }
  }, [tripId, mcId]);
  useEffect(() => {
    fetchNexusRoute();
  }, [fetchNexusRoute]);
  useEffect(() => {
    // run once on page load
    fetchNexusTrackDetails();
    fetchNexusFences();
    // handleKPIAlerts(); // initial call (optional)

    // const interval = setInterval(
    //   () => {
    //     handleKPIAlerts();
    //   },
    //   0.5 * 60 * 1000,
    // ); // 3 minutes

    // return () => clearInterval(interval); // cleanup on unmount
  }, []);

  // While the trip is ongoing, pick up newly received events. They are sorted in by
  // their event time with the rest, so they land in the right place in the table.
  useEffect(() => {
    if (Number(nexusTrip?.status) === 4) return undefined;
    const timer = setInterval(() => fetchNexusTrackDetails(true), 15000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nexusTrip?.status, tripId, mcId]);

  // Handlers for modal
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  function convertToKenyaTimeISO(dateInput) {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    const options = { timeZone: "Africa/Nairobi" };
    const year = new Intl.DateTimeFormat("en-GB", {
      ...options,
      year: "numeric",
    }).format(date);
    const month = new Intl.DateTimeFormat("en-GB", {
      ...options,
      month: "2-digit",
    }).format(date);
    const day = new Intl.DateTimeFormat("en-GB", {
      ...options,
      day: "2-digit",
    }).format(date);
    const hour = new Intl.DateTimeFormat("en-GB", {
      ...options,
      hour: "2-digit",
      hour12: false,
    }).format(date);
    const minute = new Intl.DateTimeFormat("en-GB", {
      ...options,
      minute: "2-digit",
    }).format(date);
    const second = new Intl.DateTimeFormat("en-GB", {
      ...options,
      second: "2-digit",
    }).format(date);

    return `${year}-${month}-${day}-${hour}:${minute}:${second}`;
  }
  // Columns for nexusConsign rows (keys lower-cased in fetchNexusTrackDetails)
  const consignColumns = [
    {
      title: "Consign Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Consignor",
      dataIndex: "consigner",
      key: "consigner",
      render: (text, record) => record.consignorname || getFenceNames(text),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      key: "consignee",
      render: (text, record) => record.consigneename || getFenceNames(text),
    },
    {
      title: "Delivery No",
      dataIndex: "deliveryno",
      key: "deliveryno",
      render: (text) => text || "-",
    },
    // {
    //   title: "Pickup",
    //   dataIndex: "pickuptime",
    //   key: "pickuptime",
    //   render: (value) => formatNairobiTime(value),
    // },
    // {
    //   title: "Drop",
    //   dataIndex: "droptime",
    //   key: "droptime",
    //   render: (value) => formatNairobiTime(value),
    // },
  ];
  const toModalRecord = (record) => ({
    EventName: record.eventname,
    Lat: record.lat,
    Lng: record.lng,
    MODON: record.eventtime,
    TripId: record.tripid,
    LocationName: record.locationName,
  });

  // Columns for NexusDeliveryEvents rows
  const eventColumns = [
    {
      title: "Event",
      dataIndex: "eventname",
      key: "eventname",
      render: (text, record) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {record.lat && record.lng && (
              <MapIcon
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
                onClick={() => {
                  handleOpenModal();
                  setSelectedRecord(toModalRecord(record));
                }}
              />
            )}
            <span>{text}</span>
          </div>
        );
      },
      // render: (text, record) => {
      //   const event = EventType?.find((item) => item.value === text);
      //   const eventName = event?.name || "-";
      //   return (
      //     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      //       <MapIcon
      //         style={{ width: "20px", height: "20px", cursor: "pointer" }}
      //         onClick={() => {handleOpenModal();setSelectedRecord(record)}}
      //       />
      //       <span>{`${eventName} - ${record.Code || "N/A"}`}</span>
      //     </div>
      //   );
      // },
    },
    {
      title: "Location",
      dataIndex: "fencename",
      key: "fencename",
      render: (text, record) => (
        <>
          <p>{text || "-"}</p>
          {record.dropseq != null && (
            <p style={{ color: "#979797", fontSize: 14 }}>
              Drop {record.dropseq}
            </p>
          )}
        </>
      ),
    },
    {
      title: "Updated by",
      dataIndex: "eventtime",
      key: "eventtime",
      render: (value) => (
        <>
          <p>TrackRight AI</p>
          <p>{formatNairobiTime(value)}</p>
        </>
      ),
    },
  ];
  const handleclicklogo = () => {
    window.open("https://trackright.africa/", "_blank");
  };

  const formattedTime = (dateString) => {
    return dayjs(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  return (
    <>
      <TitleStyle>
        <div
          onClick={handleclicklogo}
          style={{
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
            textAlign: "center",
            backgroundColor: "#ffffff",
            cursor: "pointer",
          }}
        >
          <Logo
            style={{
              width: "129.06866455078125",
              height: "24px",
              marginBottom: "8px",
            }}
          />
          <p className="title">(Live Consignment Tracking)</p>
        </div>

        <Row gutter={16} className="mapcontainer_two">
          {/* Left Column */}
          <Col xs={24} xxl={14} xl={14} md={14} className="mapcontainer_three">
            <div className="section-card">
              <div className="apcontainer_onee">
                <MapComponent
                  className="mapcontainer_eleven"
                  trackLink={false}
                  status={nexusSummary.status ?? consignTripData?.[0]?.STATUS}
                  containerDetailMap={arrowicondetails}
                  locationsTLAI={mapEventData}
                  containerplanedRoutes={routeData}
                  actualLocationsAI={consignTripData}
                  timeandDistAI={timeandDist}
                  trackLinktruckicon={true}
                  LocationName={mapEventData}
                />
              </div>
            </div>
            <Card style={{ marginTop: "20px" }} title="Consignments">
              <StyledTable
                columns={consignColumns}
                dataSource={nexusConsignData}
                pagination={false}
              />
            </Card>
          </Col>

          {/* Right Column */}
          <Col
            xs={24}
            md={10}
            // className="mapcontainer_one"
          >
            <Card
              title={`Trip Code : ${nexusSummary.tripCode || "N/A"}`}
              extra={
                <span>
                  Status ●{" "}
                  <span
                    style={{
                      color: nexusStatusLabel(nexusSummary.status).color,
                    }}
                  >
                    {nexusStatusLabel(nexusSummary.status).label}
                  </span>
                </span>
              }
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  rowGap: 12,
                  gridAutoRows: "min-content",
                }}
              >
                {/* {summaryData.map((item, index) => (
                  <div key={index}>
                    <strong>{item.label}</strong>
                    <div>{item.value}</div>
                  </div>
                ))} */}
                <div>
                  <strong className="textcolor">Driver Name</strong>
                  <div>
                    {nexusSummary.driverName ||
                      timeandDist[0]?.FDriverName ||
                      "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Vehicle</strong>
                  <div>
                    {nexusSummary.vehicleName ||
                      consignTripData[0]?.VEHREGNO ||
                      "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Device</strong>
                  <div>{nexusSummary.deviceId || "-"}</div>
                </div>
                <div>
                  <strong className="textcolor">Consignor</strong>
                  <div>{nexusSummary.consignorName || "-"}</div>
                </div>
                <div>
                  <strong className="textcolor">Consignee</strong>
                  <div>
                    {nexusSummary.consigneeNames.length
                      ? nexusSummary.consigneeNames.join(", ")
                      : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Delivery No</strong>
                  <div>{nexusSummary.deliveryNo || "-"}</div>
                </div>
                <div>
                  <strong className="textcolor">Carbon Footprint</strong>
                  <div>
                    {nexusSummary.carbonFootprint != null
                      ? `${nexusSummary.carbonFootprint} KgCO₂`
                      : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Pickup Time</strong>
                  <div>{formatNairobiTime(nexusSummary.pickupTime)}</div>
                </div>

                <div>
                  <strong className="textcolor">Trip ETA</strong>
                  <div>
                    {nexusSummary.dropTime
                      ? formatNairobiTime(nexusSummary.dropTime)
                      : timeandDist?.[0]?.FPlanEndTime
                        ? dayjs(timeandDist[0].FPlanEndTime).format(
                            "DD/MM/YYYY HH:mm",
                          ) // 24-hour format
                        : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Last Event</strong>
                  <div>
                    {nexusSummary.lastEventName
                      ? `${nexusSummary.lastEventName} (${formatNairobiTime(
                          nexusSummary.lastEventTime,
                        )})`
                      : "-"}
                  </div>
                </div>
                {/* <div>
                  <strong className="textcolor">Break Time</strong>
                  <div>-</div>
                </div> */}
                <div>
                  <strong className="textcolor">Last Location</strong>
                  <div>
                    {(() => {
                      const location =
                        nexusSummary.lastLocation ||
                        consignTripData[0]?.LastlocationName ||
                        "";
                      const parts = location.split(",");
                      // join the first with the second, then keep the rest as-is
                      if (parts.length > 1) {
                        return `${parts[0]} ${parts[1]}, ${parts
                          .slice(2)
                          .join(",")}`;
                      }
                      return location; // fallback if no comma exists
                    })()}
                  </div>
                </div>

                <div>
                  <strong className="textcolor">Destination Location</strong>
                  <div>
                    {(() => {
                      const location =
                        nexusSummary.destination ||
                        consignTripData[0]?.DestinationName ||
                        "";
                      const parts = location.split(",");
                      // join the first with the second, then keep the rest as-is
                      if (parts.length > 1) {
                        return `${parts[0]} ${parts[1]}, ${parts
                          .slice(2)
                          .join(",")}`;
                      }
                      return location; // fallback if no comma exists
                    })()}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Total Trip Time</strong>
                  <div>
                    {nexusSummary.tripSeconds != null
                      ? formatSecondsToHMS(nexusSummary.tripSeconds)
                      : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Distance Covered</strong>
                  <div>
                    {nexusSummary.distanceKm != null
                      ? `${Number(nexusSummary.distanceKm).toFixed(2)} Kms`
                      : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Container No</strong>
                  <div>
                    {nexusSummary.containerNo ||
                      consignTripData?.[0]?.ContainerNo ||
                      "-"}
                  </div>
                </div>
              </div>
            </Card>

            {/* <Card title="Consign Code - 23123" style={{ marginTop: 16 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                rowGap: 12,
              }}
            >
              {consignData.map((item, index) => (
                <div key={index}>
                  <strong>{item.label}</strong>
                  <div>{item.value}</div>
                </div>
              ))}
            </div>
          </Card> */}

            {/* <Card title="Stoppage" style={{ marginTop: 16 }}>
              <StyledTable
                columns={stoppageColumns}
                dataSource={StoppageData}
                pagination={false}
              />
            </Card> */}
            {/* <Card title="Trip Break(s)" style={{ marginTop: 16 }}>
              <StyledTable
                columns={breakColumns}
                dataSource={breakData}
                pagination={false}
              />
            </Card> */}
            {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
              <Card title={`Events • ${Number() === 1 ? "Import" : "Export"}`}>
                <div className="Event-card">
                  {nexusEventData.map((item, index) => (
                    <div
                      key={item.key}
                      className="items-key"
                      onClick={() => {
                        setSelectedRecord(toModalRecord(item));
                        setIsModalVisible(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {/* Vertical Line SVG */}
                      {index !== nexusEventData.length - 1 && (
                        <div className="Event-card-line">
                          <Line />
                        </div>
                      )}

                      {/* Circle Icon SVG */}
                      <div className="Event-card-circle">
                        <MapIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      {/* Event Details */}
                      <div className="Event-card-text">
                        <div className="Event-card-text-bold">
                          {item.eventname}
                        </div>
                        <div className="Event-card-text-gray">
                          <div className="Event-card-text-bold">
                            {item.fencename || item.locationName}
                          </div>
                          {/* <div className="Event-card-text-flex-calendar">
                                               <Calendar />
                                               <span>{}</span>
                                             </div> */}
                          <div className="Event-card-text-flex-clock">
                            <Clock />
                            <span>{formatNairobiTime(item?.eventtime)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            ) : (
              <Card title="Events" style={{ marginTop: 16 }}>
                <StyledTable
                  columns={eventColumns}
                  dataSource={nexusEventData}
                  pagination={false}
                />
              </Card>
            )}
          </Col>
        </Row>
      </TitleStyle>
      <Modal
        title="Event Location"
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            marginBottom: "16px",
          }}
        >
          <MapComponent
            className="maploca_"
            locationsTL={[selectedRecord]}
            triprackAI={true}
            isminimap={true}
            eventnames={selectedRecord?.EventName}
            locationName={selectedRecord?.LocationName}
            driverName={nexusSummary.driverName || timeandDist[0]?.FDriverName}
          />
          {/* Map Placeholder */}
        </div>
      </Modal>
    </>
  );
};

export default NexusTrackLinkAI;
